export default function ({ store, redirect, $vuetify }) {
  if (!localStorage.getItem('Token')) {
    redirect('/login/')
  } else {
    if (localStorage.getItem('userTheme')) {
      $vuetify.theme.themes.light = JSON.parse(
        localStorage.getItem('userTheme').toLowerCase()
      )
    }

    if (localStorage.getItem('privileges')) {
      store.dispatch(
        'user/savePrivileges',
        JSON.parse(localStorage.getItem('privileges'))
      )
    }
  }
}
